import React, { PropsWithChildren } from 'react';
import { Box, Typography, Tooltip, Flex } from '@fullstory/components';
import css from './index.module.scss';

export const SegmentHeadingText: React.FC<PropsWithChildren<unknown>> = ({ children }) => (
  <Flex data-component="SegmentHeadingText" justifyContent="flex-start">
    <Tooltip placement="bottom" tooltipContent={children}>
      <Box className={css.container}>
        <Typography variant="heading3" color="neutrals-n11">
          {children}
        </Typography>
      </Box>
    </Tooltip>
  </Flex>
);
